import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "hk-section" }
const _hoisted_2 = { class: "hk-wrap" }
const _hoisted_3 = { class: "gallery-thumb" }
const _hoisted_4 = ["src", "alt"]
const _hoisted_5 = { class: "gallery-thumb__overlay" }
const _hoisted_6 = { class: "gallery-card__title" }
const _hoisted_7 = { class: "d-flex align-center flex-wrap ga-3 mb-8" }
const _hoisted_8 = { class: "font-display gallery-category-title" }
const _hoisted_9 = { class: "gallery-thumb gallery-thumb--square" }
const _hoisted_10 = ["src"]
const _hoisted_11 = { class: "gallery-thumb__overlay" }
const _hoisted_12 = { class: "lightbox__bar" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_main_app_bar = _resolveComponent("main-app-bar")!
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_carousel_item = _resolveComponent("v-carousel-item")!
  const _component_v_carousel = _resolveComponent("v-carousel")!
  const _component_v_dialog = _resolveComponent("v-dialog")!
  const _component_v_main = _resolveComponent("v-main")!
  const _component_v_app = _resolveComponent("v-app")!

  return (_openBlock(), _createBlock(_component_v_app, null, {
    default: _withCtx(() => [
      _createVNode(_component_main_app_bar),
      _createVNode(_component_v_main, {
        class: "hk-app-bg",
        style: _normalizeStyle({ backgroundImage: 'url(' + _ctx.baseImg + ')' })
      }, {
        default: _withCtx(() => [
          _createElementVNode("section", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              (_ctx.state === 'CATEGORY')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _cache[3] || (_cache[3] = _createElementVNode("h1", { class: "hk-heading hk-heading--accent mb-3" }, "Galéria", -1)),
                    _cache[4] || (_cache[4] = _createElementVNode("p", { class: "hk-lead text-center mb-10" }, "Válassz kategóriát munkáink megtekintéséhez", -1)),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.galleryItems, (item, index) => {
                          return (_openBlock(), _createBlock(_component_v_col, {
                            key: index,
                            cols: "12",
                            sm: "6",
                            lg: "3"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                class: "hk-card hk-card--hover gallery-card",
                                onClick: ($event: any) => (_ctx.onGalleryItemClick(item.title, item.categoryFolderName, item.pictureCount))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_3, [
                                    _createElementVNode("img", {
                                      src: item.img,
                                      class: "gallery-thumb__img",
                                      alt: item.title
                                    }, null, 8, _hoisted_4),
                                    _createElementVNode("div", _hoisted_5, [
                                      _createVNode(_component_v_icon, {
                                        icon: "mdi-magnify-plus-outline",
                                        size: "34",
                                        color: "white"
                                      })
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_6, _toDisplayString(item.title), 1)
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true),
              (_ctx.state === 'PICTURES')
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                    _createElementVNode("div", _hoisted_7, [
                      _createVNode(_component_v_btn, {
                        "prepend-icon": "mdi-arrow-left",
                        variant: "text",
                        color: "primary",
                        onClick: _ctx.onBackClick
                      }, {
                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                          _createTextVNode(" Vissza a galériához ")
                        ])),
                        _: 1
                      }, 8, ["onClick"]),
                      _createElementVNode("h1", _hoisted_8, _toDisplayString(_ctx.selectedCategory), 1)
                    ]),
                    _createVNode(_component_v_row, null, {
                      default: _withCtx(() => [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedPictures, (picture, index) => {
                          return (_openBlock(), _createBlock(_component_v_col, {
                            key: index,
                            cols: "6",
                            sm: "4",
                            lg: "3"
                          }, {
                            default: _withCtx(() => [
                              _createVNode(_component_v_card, {
                                class: "hk-card hk-card--hover gallery-card",
                                onClick: ($event: any) => (_ctx.onPictureItemClick(picture, index))
                              }, {
                                default: _withCtx(() => [
                                  _createElementVNode("div", _hoisted_9, [
                                    _createElementVNode("img", {
                                      src: picture,
                                      class: "gallery-thumb__img",
                                      alt: "Hímzett munka"
                                    }, null, 8, _hoisted_10),
                                    _createElementVNode("div", _hoisted_11, [
                                      _createVNode(_component_v_icon, {
                                        icon: "mdi-magnify-plus-outline",
                                        size: "30",
                                        color: "white"
                                      })
                                    ])
                                  ])
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ]),
                            _: 2
                          }, 1024))
                        }), 128))
                      ]),
                      _: 1
                    })
                  ], 64))
                : _createCommentVNode("", true)
            ])
          ]),
          _createVNode(_component_v_dialog, {
            modelValue: _ctx.pictureDialog,
            "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.pictureDialog) = $event)),
            "max-width": "1100",
            class: "lightbox"
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_12, [
                _createVNode(_component_v_btn, {
                  icon: "mdi-close",
                  variant: "text",
                  color: "white",
                  onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.pictureDialog = false))
                })
              ]),
              _createVNode(_component_v_carousel, {
                modelValue: _ctx.selectedSlide,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.selectedSlide) = $event)),
                "hide-delimiters": "",
                "show-arrows": "hover",
                height: "80vh",
                class: "lightbox__carousel"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.selectedPictures, (item, i) => {
                    return (_openBlock(), _createBlock(_component_v_carousel_item, {
                      key: i,
                      src: item,
                      cover: "",
                      "reverse-transition": "fade-transition",
                      transition: "fade-transition"
                    }, null, 8, ["src"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["modelValue"])
            ]),
            _: 1
          }, 8, ["modelValue"])
        ]),
        _: 1
      }, 8, ["style"])
    ]),
    _: 1
  }))
}